/**
 * Sorting getters
 */
export const SORTING_PRICE_LOWEST = 'getListSortedByPriceLowest';
export const SORTING_PRICE = 'getListSortedByLowest';
export const SORTING_STOPS = 'getListSortedByStops';
export const SORTING_CABIN = 'getListSortedByCabin';
export const SORTING_AIRLINES = 'getListSortedByAirlines';

/**
 * Errors
 */
export const ERROR_DEEP_DATE = pageConfig.errorCodes.errorDeepDate;
export const ERROR_OVERLAPPING = pageConfig.errorCodes.errorOverlapping;
export const ERROR_PASSENGERS_NUMBER = pageConfig.errorCodes.errorPassengersNumber;
export const ERROR_NO_FLIGHTS = pageConfig.errorCodes.errorNoFlights;
export const ERROR_DEFAULT_TEXT = 'Something went wrong. Please try again later.';
export const ERROR_EMPTY_DEPARTURE_ORIGIN_LOCATION = 'Please select the departure origin.';
export const ERROR_EMPTY_DEPARTURE_DESTINATION_LOCATION = 'Please select the departure destination.';
export const ERROR_EMPTY_DEPARTURE_DATE = 'Please select the departure date.';

/**
 * Way type constants
 */
export const WAY_ONE = 'one';
export const WAY_ROUND = 'round';

/**
 * Trip search mode constants
 */
export const FLIGHT_RECOMMENDED = 'recommended';
export const FLIGHT_CUSTOM = 'custom';

/**
 * Traveller constants
 */
export const TRAVELLER_ADULT_CODE = 'ADT';
export const TRAVELLER_CHILD_CODE = 'CHD';
export const TRAVELLER_CHILD_CODE_ADDITIONAL = 'CNN';
export const TRAVELLER_INFANT_CODE = 'INF';
export const TRAVELLER_ADULT_LABEL = 'Adult';
export const TRAVELLER_CHILD_LABEL = 'Child';
export const TRAVELLER_INFANT_LABEL = 'Infant';
export const TRAVELLER_TRAVELER_LABEL = 'Traveler';

/**
 * Validation rules
 */
export const rules = {
    required(message) {
        return {
            required: true,
            message: message ? message : 'Required field',
            trigger: ['blur', 'change']
        };
    },
    email(message) {
        return {
            type: 'email',
            message: message ? message : 'Please input correct email address',
            trigger: ['blur', 'change']
        };
    },
    date(message) {
        return {
            type: 'date',
            message: message ? message : 'Please pick a date',
            trigger: 'change'
        };
    }
};

/**
 * Config
 *
 * @var {Object}
 */
export const config = {
    userId: pageConfig.userId ? pageConfig.userId : 0,
    currency: {
        symbol: pageConfig.currency.symbol,
        position: pageConfig.currency.position,
        precision: pageConfig.currency.precision
    },
    countries: pageConfig.countries ? pageConfig.countries : [],
    trip: {
        route: {
            search: pageConfig.searchTripRoute,
            select: pageConfig.selectTripRoute,
            purchase: pageConfig.flightPurchaseRoute
        }
    },
    locations: {
        route: {
            airports: pageConfig.searchAirports,
            airlines: pageConfig.searchAirlines,
            autocomplete: pageConfig.searchLocations
        }
    },
    cart: {
        services: pageConfig.updateServicesRoute,
        paymentType: pageConfig.updatePaymentTypeRoute,
        recalculateCouponPrices: pageConfig.recalculateCouponPricesRoute
    },
    sortingTitles: {
        priceLowest: pageConfig.sorting.priceLowest,
        price: pageConfig.sorting.price,
        stops: pageConfig.sorting.stops,
        cabin: pageConfig.sorting.cabin,
        airlines: pageConfig.sorting.airlines
    },
    recommendedFlights: pageConfig.recommendedFlights ? pageConfig.recommendedFlights : [],
    extraServices: pageConfig.extraServices ? pageConfig.extraServices : [],
    rooms: pageConfig.rooms ? {
        count: pageConfig.rooms.count,
        price: pageConfig.rooms.price
    } : null,
    payment: pageConfig.payment ? pageConfig.payment : {},
    location: pageConfig.location ? pageConfig.location : {},
    travellers: pageConfig.travellers ? pageConfig.travellers : {
        adt: 1,
        chd: 0,
        inf: 0
    },
    wayType: WAY_ROUND,
    dates: pageConfig.dates ? pageConfig.dates : {
        departureDate: ((date) => date.getTime() / 1000)(new Date()),
        returnDate: ((date) => date.getTime() / 1000)(new Date())
    },
    errorMessages: pageConfig.errorMessages,
    errorMessage: (errorCode) => {
        return config.errorMessages.find(errorMessage => errorMessage.code === errorCode);
    },
    errorMessageText: (errorCode) => {
        const errorMessage = config.errorMessage(errorCode);
        return errorMessage ? errorMessage.text : ERROR_DEFAULT_TEXT;
    },
    routeBase: pageConfig.routeBase ? pageConfig.routeBase : null,
    defaultPassportImage: pageConfig.defaultPassportImage ? pageConfig.defaultPassportImage : null,
    square: {
        applicationId: pageConfig.square && pageConfig.square.applicationId ? pageConfig.square.applicationId : '',
        locationId: pageConfig.square && pageConfig.square.locationId ? pageConfig.square.locationId : ''
    }
};
